import { render, staticRenderFns } from "./table12.vue?vue&type=template&id=fecf5316&scoped=true&"
import script from "./table12.vue?vue&type=script&lang=js&"
export * from "./table12.vue?vue&type=script&lang=js&"
import style0 from "./table12.vue?vue&type=style&index=0&id=fecf5316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecf5316",
  null
  
)

export default component.exports